const base64ToUint8 = (b64) => {
    const bin = atob(b64);
    const u8 = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
    return u8;
};

const uint8ToBase64 = (u8) => {
    let s = '';
    const CHUNK = 0x8000;
    for (let i = 0; i < u8.length; i += CHUNK)
        s += String.fromCharCode.apply(null, u8.subarray(i, i + CHUNK));
    return btoa(s);
};

export const decodeCloudItem = async (item) => {
    if (item.type !== 'proimager') return item;
    if (item.encoding === 'gzip+base64' && item.blob) {
        try {
            const ds = new DecompressionStream('gzip');
            const stream = new Blob([base64ToUint8(item.blob)]).stream().pipeThrough(ds);
            const pngBuf = await new Response(stream).arrayBuffer();
            return { ...item, src: `data:image/png;base64,${uint8ToBase64(new Uint8Array(pngBuf))}` };
        } catch { return item; }
    }
    if (item.encoding === 'none' && item.blob) {
        return { ...item, src: `data:image/png;base64,${item.blob}` };
    }
    return item;
};